import SearchIcon from '@src/assets/images/common/icon/search/SearchIcon';

function SearchEmptyState() {
  return (
    <div className='flex flex-1 flex-col items-center justify-center'>
      <SearchIcon
        width={120}
        height={120}
        color='#D9D9D9'
      />
      <div className='mt-4 text-sm'>キーワードでメッセージの検索ができます</div>
    </div>
  );
}

export default SearchEmptyState;
